import React, { useContext } from "react";
import { AppContext } from "../../AppDataProvider/AppDataProvider";
import { GenericServiceData } from "./GenericServiceData/GenericServiceData";
import { ServiceData } from "./ServiceData/ServiceData";

/**
 * Loads either booking tool specific service data
 * or generic organisation service data with no
 * connection to a specific booking tool.
 */
export function ServiceStep() {
  const {
    appData
  } = useContext(AppContext);
  const {
    isGenericBookingTool
  } = appData.bookingTool;
  return isGenericBookingTool ? <GenericServiceData /> : <ServiceData />;
}
export default ServiceStep;